import { useEffect } from "react";
import TopNav from "./components/TopNav";
import HeroSection from "./sections/HeroSection";
import PlatformWorkflowSection from "./sections/PlatformWorkflowSection";
import RealtimeIntelSection from "./sections/RealtimeIntelSection";
import ExecutionSection from "./sections/ExecutionSection";
import PersonalizationSection from "./sections/PersonalizationSection";
import IntegrationsSection from "./sections/IntegrationsSection";
import DifferentiationSection from "./sections/DifferentiationSection";
import PricingSection from "./sections/PricingSection";
import FaqsSection from "./sections/FaqsSection";
import TeamSection from "./sections/TeamSection";
import FinalCtaSection from "./sections/FinalCtaSection";
import FooterSection from "./sections/FooterSection";

export default function LandingHomeV2() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Shadow · Real-time intelligence for every revenue call";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans text-neutral-900 antialiased">
      <TopNav />
      <main>
        <HeroSection />
        <PlatformWorkflowSection />
        <RealtimeIntelSection />
        <ExecutionSection />
        <PersonalizationSection />
        <IntegrationsSection />
        <DifferentiationSection />
        <PricingSection />
        <FaqsSection />
        <TeamSection />
        <FinalCtaSection />
      </main>
      <FooterSection />
    </div>
  );
}
